import auth from './auth.store.js';
import draft from './draft.store.js';
import feedback from './feedback.store.js';
import memberships from './memberships.store.js';
import resources from './resources.store.js';
import whitelabel from './whitelabel.store.js';

export default {
  auth,
  draft,
  feedback,
  memberships,
  resources,
  whitelabel,
};
